'use strict'

/**
 * This same schedule dialog is used for single schedule, bulk schedule and group schedule.
 * If the options object of the model contains a group property or bulkAction property the
 * saving of the models is threated differently.
 */

var _ = require('lodash')

var EditNewController = require('src/components/edit_new-controller.js')
var Backbone = require('backbone')
var App = require('app')

var Helpers = require('src/common/helpers')
var View = require('./view.js')
var Tabs = require('src/behaviors/tabs')
var RoutineComposer = require('src/components/routine-composer')
var DialogModel = require('src/common/dialog-model.js')

var ScheduleEditNew = function (options) {
  var Controller = EditNewController.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region

      self.schedule = options.schedule
      self.scheduleCollection = options.collection

      var clients = App.globalChannel.request('client:entities:cached')
      var device = options.device
      var group = options.group
      var schedule = options.model

      if (group) {
        self.deviceType = group.get('type')
        var client = clients.get(group.get('client'))
      } else if (device) {
        self.deviceType = device.get('type')
        var client = clients.get(device.get('client'))
      }

      self.device = device
      self.routineComposers = []

      //
      if (!schedule) schedule = App.globalChannel.request('schedule:entity:new')

      // define the dialog model
      var dialogModel = new DialogModel({
        title: 'Schedule',
        buttons: {
          left: [
            { label: 'delete', icon: true, slug: 'delete', action: 'dialog:delete', roles: ['super', 'admin'] }
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        }
      })

      //
      this.view = this.getView(dialogModel, schedule, client, self.deviceType)

      this.listenTo(this.view, 'render', function (view) {
        var routine = schedule.get('commands') || []
        self.bodyRegion(schedule, client, routine, self.deviceType)
      })

      this.listenTo(this.view, 'dialog:submit', self.onScheduleSave)
      this.listenTo(this.view, 'dialog:load-preset', this.onLoadPreset)
      this.listenTo(this.view, 'dialog:delete', this.onDelete)

      this.region.show(this.view)
    },
    // scheduleControl: function (data) {
    //   var self = this
    //
    //   if (!self.schedule) {
    //     self.schedule = App.globalChannel.request('schedule:entity:new')
    //   }
    //
    //   data['commands'] = data.routines
    //   data['devices'] = [self.device.id]
    //   delete data.routines
    //
    //   self.schedule.save(data, {
    //     success: function (a) {
    //       if (self.options.collection) self.options.collection.add(a)
    //     }
    //   })
    // },
    parseRoutines: function (view) {
      var routines = []
      for (var i = 0; i < this.routineComposers.length; i++) {
        var composer = this.routineComposers[i]
        routines = routines.concat(composer.getRoutine())
      }
      return routines
    },
    /* Regions --------------------------------------------------------------- */
    bodyRegion: function (device, client, routine, deviceType) {
      var self = this
      
      var bodyView = self.getBodyView(device, client, deviceType)

      this.listenTo(bodyView, 'render', function (view) {
        self.routineRegion(bodyView, routine)
      //     if (self.options.device) routine = device.get('defaultSchedule') ||
      })
      this.listenTo(bodyView, 'control:load-preset', this.onLoadPreset)
      this.listenTo(bodyView, 'control:send-command', this.onSendCommand)

      self.view.showChildView('bodyRegion', bodyView)
    },
    routineRegion: function (view, commands) {
      var self = this
      var types = false

      var routineByType = Helpers.convertCommandsToRoutine(commands)

      switch (self.deviceType) {
        case 'ird_driver':
        case 'rtm_rc':
        case '9w_driver':
        case '21w_driver':
        case '9w_driver_dc':
        case '21w_driver_dc':
        case 'rtm_lc':
        case 'rtm_zsc_v1':
        case 'rtm_dali_x':
        case 'rtm_zsc_100':
        case 'rtm_zsc_f':
        case 'rtm_zsc_r':
        case 'rtm_zsc_s':
        case 'rtm_zsc':
          types = ['dali']
          break
        case 'rgb_driver':
          types = ['color']
          break
        case 'ird_rgb_driver':
          types = ['dali', 'color']
          break
        case 'rtm_zsc_rgbw':
        case 'rtm_zsc_130':
          types = ['color_rgbw']
          break
        case 'rtm_io':
          types = ['gpio']
          break
      }

      for (var i = 0; i < types.length; i++) {
        var type = types[i]
        var composer = new RoutineComposer({
          region: view.getRegion('routineRegion_' + type),
          type: type,
          dayRoutine: true, // when set to true this is not a week routine
          deviceType: self.deviceType,
          routine: routineByType[type]
        })
        self.routineComposers.push(composer)
      }
    },
    /* Event methods --------------------------------------------------------- */
    onLoadPreset: function (view, presetId) {
      var self = this

      if (!view.options.client.get('presets')) return false

      var preset = _.find(view.options.client.get('presets'), function (o) { return o._id === presetId })
      self.routineRegion(view, preset.settings)
    },
    onScheduleSave: function (view) {
      var self = this
      var data = Backbone.Syphon.serialize(view)

      var group = self.options.group || false
      var device = self.options.device || false

      var scheduleType = ''

      // remove some debris
      delete data.sectionId
      delete data.height
    
      // prepare the routine for saving
      var routines = self.parseRoutines()

      routines.forEach (function(element) {
        if (element.time == 126000) {
          element.time = 125999
        }
      })

      if (routines.length > 0) data['commands'] = routines
      delete data.routine

      if (view.options.model.isNew()) {
        if (group) {
          data.type = 'group'
          data.groups = [group.id]
        } else if (device) {
          data.type = 'device'
          data.devices = [device.id]
        }
      }
      // check if the routines are different from the stored routines
      // if thats the case don't add them to the PUT because otherwise the server
      // fires a command to the devices
      if (Helpers.deepEqual(view.options.model.get('commands'), routines)) {
        delete data.commands
      }

      self.processFormSubmit(data, view.options.model, self.scheduleCollection, function () {
        self.region.empty()
      })
    },
    /* Views ----------------------------------------------------------------- */
    getBodyView: function (device, client, deviceType) {
      var view
      switch (deviceType) {
        case 'ird_rgb_driver':
          view = View.BodyIrdRgbDriver
          break
        case 'ird_driver':
        case 'rtm_rc':
        case 'rtm_lc':
        case 'rtm_zsc':
          view = View.BodyIrdDriver
          break
        case '9w_driver':
        case '21w_driver':
        case '9w_driver_dc':
        case '21w_driver_dc':
          view = View.BodyXwDriver
          break
        case 'rgb_driver':
          view = View.BodyRgbDriver
          break
        default:
          view = View.Body

          break
      }

      return new view({
        model: device,
        client: client,
        deviceType: deviceType
      })
    },
    getView: function (dialogModel, schedule, client, deviceType) {
      return new View.Layout({
        dialogModel: dialogModel,
        model: schedule,
        client: client,
        deviceType: deviceType
      })
    }
  })

  return new Controller(options)
}

module.exports = ScheduleEditNew



// WEBPACK FOOTER //
// ./js/modules/schedules/edit_new/index.js